<template>
    <el-row type="flex" align="middle" justify="start">
        <div class="navbar-item" v-for="(nav, index) in navbars" :key="'nav-item' + index" :style="{
            backgroundColor: (index + 1) === value ? '#256CF4' : '#EFF2F6',
            clipPath: index === 0 ? 'polygon(0% 0%, 86% 0%, 100% 50%, 100% 52%, 86% 100%, 0% 100%, 0% 0%)' :
            'polygon(0% 0%, 86% 0%, 100% 50%, 100% 52%, 86% 100%, 0% 100%, 10% 50%, 0% 0%)'
        }">
            <div class="navbar-item--icon" :style="{
                color: (index + 1) === value ? '#256CF4' : '#868EA1',
                fontSize: (index + 1) === value ? '22px' : '17px'
            }">{{ index + 1 }}</div>
            <div class="navbar-item--text" :style="{color: (index + 1) === value ? '#FFFFFF' : '#868EA1'}">{{ nav }}</div>
        </div>
    </el-row>
</template>

<script>
export default {
    name: "Navbar",
    data() {
        return {
            navbars: ["新建考试", "选择试卷", "选择考生"]
        }
    },
    props: {
        value: {}
    }
}
</script>

<style scoped lang="less">
.navbar-item {
    flex: 1;
    border-radius: 3px;
    height: 48px;
    color: #FFFFFF;
    border: none;
    max-width: 220px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    transition: all .28s;
    &--icon {
        width: 38px;
        height: 80%;
        clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%, 50% 0);
        -webkit-clip-path: polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%, 50% 0);
        background: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 20px;
    }
}

</style>
